(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cachoteries-video-modal"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-video-modal]').forEach((modal) => {
    const modalVideo = modal.querySelector('[data-video-modal-video]');
    const closeBtn = modal.querySelector('[data-video-modal-close]');
    const backdrop = modal.querySelector('[data-video-modal-backdrop]');

    function closeModal() {
      modalVideo.pause();
      modalVideo.src = '';
      modal.hidden = true;
    }

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    document.querySelectorAll('[data-video-fullscreen-trigger]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const wrap = btn.closest('[data-video-wrap]');
        const video = wrap.querySelector('video');
        const source = video.querySelector('source');
        modalVideo.src = source ? source.src : video.src;
        modalVideo.currentTime = video.currentTime;
        modal.hidden = false;
        modalVideo.play().catch(() => {});
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
